import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-table-widget-menuitem',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent extends ButtonComponent implements OnInit {

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }

  getClass() {
    if (this.getStyles() && this.getColor()) {
      return this.getStyles() + ' ' + this.getColor();
    } else if (this.getStyles()) {
      return this.getStyles();
    } else if (this.getColor()) {
      return this.getColor();
    } else {
      return undefined;
    }
  }
}
